import { create } from 'zustand';

interface ReceiptState {
  /** The post whose receipt is open, or null. */
  postId: string | null;
  open: (postId: string) => void;
  close: () => void;
}

/**
 * Which post's receipt is open (Task 1.3). Any screen opens one here; the
 * one `ReceiptHost` in the app layout shows it, together with a
 * `?receipt=<postId>` link (notifications).
 */
export const useReceiptStore = create<ReceiptState>()((set) => ({
  postId: null,
  open: (postId) => set({ postId }),
  close: () => set({ postId: null }),
}));
